import { PropsWithChildren } from 'react';

type TLightboxMainProps = PropsWithChildren;

export const LightboxMain = ({ children }: TLightboxMainProps) => {
    return <div className="flex-grow pt-5 md:pt-0">{children}</div>;
};
